import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppUserBlacklistListDataApi(data) {
  return request({
    url: "web/appUserBlacklist/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppUserBlacklistExportDataApi(data) {
  return request({
    url: "web/appUserBlacklist/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppUserBlacklistApi(data) {
  return request({
    url: "web/appUserBlacklist/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppUserBlacklistApi(data) {
  return request({
    url: "web/appUserBlacklist/init",
    method: "post",
    data
  });
}

// 下拉列表
export function getAppUserBlacklistListApi(data) {
  return request({
      url: "web/appUserBlacklist/listSelectData",
      method: "post",
      data
  });
}